import { SearchOptions, SearchState } from '../../types'
import { debounce } from 'application/utils/helpers'

/**
 * Класс для управления поиском в каталоге
 */
export class Search {
  private element: HTMLElement
  private options: SearchOptions
  private state: SearchState

  // DOM элементы
  private input: HTMLInputElement
  private clearButton: HTMLButtonElement

  /**
   * Создаёт экземпляр Search
   *
   * @param {SearchOptions} options - Опции поиска
   */
  constructor(options: SearchOptions) {
    this.options = options
    this.element = options.element

    // Инициализируем состояние
    this.state = {
      value: ''
    }

    this.init()
  }

  private init(): void {
    this.getElements()
    this.bindEvents()
  }

  private getElements(): void {
    this.input = this.element.querySelector(
      '[data-search-input]'
    ) as HTMLInputElement
    this.clearButton = this.element.querySelector(
      '[data-search-clear]'
    ) as HTMLButtonElement
  }

  private bindEvents(): void {
    const debouncedHandleInput = debounce(this.handleInput.bind(this), 600)

    // Ввод в поле: UI сразу, поиск с debounce
    this.input.addEventListener('input', (event) => {
      const target = event.target as HTMLInputElement
      this.state.value = target.value
      this.updateUI()
      debouncedHandleInput()
    })

    // Кнопка очистки
    this.clearButton.addEventListener('click', this.reset.bind(this))
  }

  private handleInput(): void {
    if (this.options.onChange) {
      this.options.onChange(this.state.value)
    }

    // Отправляем событие для интеграции с каталогом
    const changeEvent = new CustomEvent('search-change', {
      detail: this.state.value,
      bubbles: true
    })
    this.element.dispatchEvent(changeEvent)
  }

  private reset(): void {
    this.state.value = ''
    this.input.value = ''
    this.updateUI()

    if (this.options.onChange) {
      this.options.onChange(this.state.value)
    }

    // Отправляем событие
    const changeEvent = new CustomEvent('search-change', {
      detail: {
        search: this.state.value
      },
      bubbles: true
    })
    this.element.dispatchEvent(changeEvent)
  }

  private updateUI(): void {
    this.clearButton.classList.toggle('is-visible', this.state.value.length > 0)
  }

  /**
   * Возвращает текущее значение поиска
   *
   * @return {any} Текст поискового запроса
   */
  // Публичные методы
  public getValue(): string {
    return this.state.value
  }

  /**
   * Устанавливает значение поиска
   *
   * @param {string} value - Новое значение
   */
  public setValue(value: string): void {
    this.state.value = value
    this.input.value = value
    this.updateUI()
  }

  /**
   * Очищает поле поиска
   */
  public clear(): void {
    this.reset()
  }

  /**
   * Уничтожает экземпляр поиска
   */
  public destroy(): void {
    // Удаляем обработчики при необходимости
  }
}

/**
 * Инициализирует все экземпляры поиска на странице
 */
// export function initSearch(): void {
//   const searchElements = document.querySelectorAll<HTMLElement>('[data-search]')

//   searchElements.forEach((element) => {
//     const placeholder = element.dataset.searchPlaceholder

//     new Search({
//       element,
//       placeholder
//     })
//   })
// }
